import { MoveRight } from 'lucide-react';
import React, { useCallback } from 'react';
import { useMatch, useNavigate } from 'react-router-dom';
import { theme } from 'styles/theme/theme';
import UDButton from '../button';

import { Divider } from '../divider';
import UDText from '../text';
import { UDTabProps } from './interfaces';

export const UdTab = ({ tab, activeRoutePattern }: UDTabProps) => {
  const navigate = useNavigate();
  const isActive = Boolean(useMatch(`${activeRoutePattern}/${tab.hash}/*`));

  const handleTabClick: React.MouseEventHandler<HTMLButtonElement> = useCallback(
    (e) => {
      const tabPath = e.currentTarget.dataset.hash;
      if (tabPath) {
        tab.onClick?.();
        navigate(tabPath, { replace: true, state: tab.state });
      }
    },
    [navigate, tab],
  );

  return (
    <div className="control flex items-center">
      <UDButton
        key={tab.hash}
        disabled={tab.disabled}
        variant={isActive ? 'primary' : 'light'}
        data-hash={tab.hash}
        onClick={handleTabClick}
        type="button"
        className="flex items-center"
      >
        {tab.label}
        {!isActive && <MoveRight size={16} className="ml-2" color={theme.colors.SurfaceRomanSilver30} />}
      </UDButton>
      {tab.subLabel && (
        <>
          <Divider type={'horizontal'} color={theme.colors.AccentNaplesYellow} height={'1px'} width={'17px'} />
          <UDButton
            key={tab.hash}
            disabled={tab.disabled}
            variant={'secondary'}
            data-hash={tab.hash}
            type="button"
            className="flex items-center"
          >
            <UDText type={'subhead'} maxWidth={145}>
              {tab.subLabel}
            </UDText>
          </UDButton>
        </>
      )}
    </div>
  );
};
